import { createFileRoute } from '@tanstack/react-router';
import { CriteriaTab } from '@/components/health-readiness/criteria-tab';

/** Health & Readiness → Go-live criteria (T-0242): the first criterion opens. */
export const Route = createFileRoute('/engagements/$engagementId/health-readiness/criteria/')({
  component: CriteriaIndexRoute,
});

function CriteriaIndexRoute() {
  const { engagementId } = Route.useParams();
  return <CriteriaTab engagementId={engagementId} />;
}
